<template>
  <label class="switch" :class="props.customClass">
    <input
      :class="[{ 'switch-checked': props.modelValue === props.trueValue }]"
      :disabled="props.disabled"
      @click="toggle"
      type="checkbox"
    >
    <span>
      <slot/>
    </span>
  </label>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: null,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: null,
      default: true,
    },
    falseValue: {
      type: null,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
  });

  const emit = defineEmits(['update:modelValue']);

  function toggle() {
    if (props.readonly || props.disabled) {
      return;
    }

    if (props.modelValue === props.trueValue) {
      emit('update:modelValue', props.falseValue);
    } else {
      emit('update:modelValue', props.trueValue);
    }
  }
</script>
